import CarouselInicio from '../Carrosuel-Inicio/Carrousel-Inicio';
import ProductFamily from '../ProductFamily/ProductFamily';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OurHistory from '../OurHistory/OurHistory';
import Cocktails from '../Cocktails/Cocktails';
import MainNews from '../MainNews/MainNews';
import Advantages from '../Advantages/Advantages';
import '../Main/Main.css';
import ModalWelcome from '../ModalWelcome/ModalWelcome';
import ContactUs from '../ContactUs/ContactUs';
import Navbar from "../../components/Navbar/Navbar"
import Footer from '../../components/Footer/Footer';

function Main() {


    return (
        <Container >
          {/* Modal de Bienvenida */}
            <ModalWelcome/>
        
        <Row>
          <Col><CarouselInicio/></Col>
        </Row>
        <Row style={{ backgroundColor: 'white', marginTop: '30px', opacity:'0.9'}}>
          <Col><ProductFamily/></Col>
        </Row>
        <hr/>
        <Row>
          <Col><OurHistory/></Col>
        </Row>
        <hr/>
        <Row>
          <Col><Advantages/></Col>
        </Row>
        <hr/>
        <Row style={{ padding: '3px'}}>
          <Col><Cocktails/></Col>
        </Row>
        {/* <Row>
          <Col><MainNews/></Col>
        </Row> */}
        
        {/* Boton de Contacto */}
          <ContactUs />
      </Container>
    );
}

export default Main;